/**
 * @file
 * Select Videos Brick video toggle.
 */
(($, Drupal) => {
  Drupal.behaviors.selectVideos = {
    attach: function (context, settings) {
      
      const selectVideoBricks = document.querySelectorAll('.brick--select-videos', context);
      if (!selectVideoBricks.length) {
        return;
      }

      selectVideoBricks.forEach(brick => {
        let videos = brick.querySelectorAll('.videos [data-video]', context);
        let links = brick.querySelectorAll('.videos-thumbnails a.video-thumbnail', context);
        if (links.length) {
          links.forEach(link => {
            link.addEventListener('click', e => {
              e.preventDefault();
              let thumbId = link.dataset.videoThumb;
              videos.forEach(video => {
                let videoItem = video.dataset.video;
                if (videoItem == thumbId) {
                  video.style.display = 'block';
                }
                else {
                  video.style.display = 'none';
                }
              })
              links.forEach(item => {item.setAttribute('aria-current', false)});
              link.setAttribute('aria-current', true);
            })
          })
        }
      })

    }
  }
})(jQuery, Drupal);
